import type { ReactNode } from 'react';
import styles from './BottomSheet.module.css';

export interface BottomSheetProps {
  onClose?: () => void;
  fill?: boolean;
  children: ReactNode;
}

export function BottomSheet({ onClose, fill = false, children }: BottomSheetProps) {
  return (
    <>
      {onClose !== undefined && <div className={styles.scrim} data-part="scrim" data-motion="scrim" onClick={onClose} />}
      <div className={styles.sheet} data-part="sheet" data-motion="sheet" data-fill={fill ? 'true' : undefined}>
        <div className={styles.grabber} data-part="grabber" aria-hidden="true"><span className={styles.handle} /></div>
        {children}
      </div>
    </>
  );
}
